/**
 * Action button interface for OverviewTitle component
 */
export interface ActionButton {
  id: string;
  label: string;
  icon: 'Add' | 'Download';
  kind: 'filled' | 'outlined';
  onClick?: () => void;
}

/**
 * OverviewTitle component props interface
 */
export interface OverviewTitleProps {
  title?: string;
  actions?: ActionButton[];
  onAddLicenseClick?: () => void;
}
export const DEFAULT_ACTIONS: ActionButton[] = [
  {
    id: 'add-license',
    label: 'Add License',
    icon: 'Add',
    kind: 'filled',
  },
];
